export const handleAssetCount = arr => {
  if (!arr) return []
  const videoAssets = arr.filter(video => video._type === "video").length
  const imageAssets = arr.filter(image => image._type === "mainImage").length
  const video = videoAssets > 0 ? `video (${videoAssets})` : ""
  const image = imageAssets > 0 ? `image (${imageAssets})` : ""
  const separator = video && image && ", "
  const assetCount = `${video}${separator}${image}`

  return assetCount
}
